export default {
  body: {
    cmpt: {
      type: 'CNewCategory'
    }
  }
}
